export default {
	brands: "Brand",
	mystery_shopper: "Mystery Shopper",
	of_the_points: "of the points",
	photos: "Photos",
	practice_display_and_recommend_products_with_intel_tecnology_and_you_can_redeem_the_best_prizes: "With Intel Rewards You program, you can accumulate points and redeem them for a whole universe of prizes and benefits!",
	processors: "Processors",
	product_types: "Product Type",
	pts: "pts",
	score: "Score",
	training_kpi_points: "Training",
	trainings_kpi: "Trainings KPI",
	trainings_non_kpi: "Trainings non KPI",
	webinars: "webinar"
}